import { createContext } from 'react'

import type { TAirbyteContextData } from './types'

export const AirbyteContext = createContext<TAirbyteContextData | null>(null)
